import classNames from 'classnames';
import { ComponentProps } from 'react';

type FillPillOwnProps = {
  current: number
  total: number
  notFilledApplications: number
  finished: boolean
};

type FillPillProps = FillPillOwnProps & Omit<ComponentProps<'div'>, keyof FillPillOwnProps>;

const FillPill = ({ current, total, notFilledApplications, finished, ...rest }: FillPillProps) => {
  return (
    <div
      className={
        classNames(
          'h-5 flex justify-center rounded-md border border-secondary-transparent-5',
          'w-full font-normal ',
          {'bg-secondary-transparent-5': !finished}
        )
      }
      {...rest}
    >
      <span className={classNames(
        'flex justify-center items-center',
        'border-r border-secondary-transparent-5',
        'w-full'
      )}
      >
      {current}/{total}
      </span>
      <span className={classNames(
        ' w-7 flex justify-center items-center text-secondary-transparent-48',
      )}
      >
      {notFilledApplications}
      </span>
    </div>
  );
};

export default FillPill;
